import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
const CUIPolicyModal = props => {
  const acceptCUIPolicy = props.loginActions.acceptCUIPolicy;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    className: "t-cuipm"
  }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("p", null, "By logging in to TRU, you may encounter CUI and it is your responsibility to treat such data pursuant to your organization's security protocols. TRU monitors and audits the platform's security and compliance controls, but does not own your data. Unauthorized use of this cloud service is prohibited. Please confirm by clicking \" Ok\" below.")), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => acceptCUIPolicy()
  }, "Ok")));
};
CUIPolicyModal.propTypes = {
  loginActions: PropTypes.shape({
    acceptCUIPolicy: PropTypes.func
  }).isRequired
};
export { CUIPolicyModal as TestCUIPolicyModal };
export default entityComposition(CUIPolicyModal, [], {}, ['login']);